import { render, staticRenderFns } from "./TurntablePromo.vue?vue&type=template&id=c29c3f2a&scoped=true"
import script from "./TurntablePromo.vue?vue&type=script&lang=js"
export * from "./TurntablePromo.vue?vue&type=script&lang=js"
import style0 from "./TurntablePromo.vue?vue&type=style&index=0&id=c29c3f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29c3f2a",
  null
  
)

export default component.exports